import React from 'react';
import {ResursLoading as ResursLoadingMui} from '@resurs-internal/mui';
import {ResursLoadingProps} from '@resurs-internal/mui/components/ResursLoading/ResursLoading';

type ReactSpinnerProps = ResursLoadingProps;

export const ResursLoading: React.FC<ReactSpinnerProps> = ({
  size = 'xxl',
  style,
  ...rest
}) => {
  return (
    <ResursLoadingMui
      id="resurs_loading"
      size={size}
      style={{...style}}
      {...rest}
    />
  );
};
